import React from 'react'
import PropTypes from 'prop-types'

// component
import { Col, Row } from 'reactstrap'
import InternalRequestCard from 'domains/internal-request/molecules/internal-request-card'

const propTypes = {
  internal_request: PropTypes.shape({
    // id                : PropTypes.number,
    // inventory_sku     : PropTypes.string,
    // quantity          : PropTypes.number,
    // sellable_quantity : PropTypes.number,
    // product           : PropTypes.shape({
    //   name             : PropTypes.string,
    //   main_image       : PropTypes.string,
    //   productable_type : PropTypes.string,
    //   sku              : PropTypes.string,
    //   details          : PropTypes.object,
    //   status           : PropTypes.string
    // }),
    // product_dimension: PropTypes.shape({
    //   id           : PropTypes.number,
    //   size         : PropTypes.string,
    //   measurements : PropTypes.object
    // })
    id             : PropTypes.number,
    code           : PropTypes.string,
    purpose        : PropTypes.string,
    status         : PropTypes.string,
    requested_date : PropTypes.string,
    returned_date  : PropTypes.string,
    requestor      : PropTypes.shape({
      name  : PropTypes.string,
      email : PropTypes.string
    }),
    ops_sender: PropTypes.shape({
      name  : PropTypes.string,
      email : PropTypes.string
    }),
    ops_receiver: PropTypes.shape({
      name  : PropTypes.string,
      email : PropTypes.string
    }),
    put_away_completed_by: PropTypes.shape({
      name  : PropTypes.string,
      email : PropTypes.string
    })
  })
}

/**
 * Show card information about Internal Request
 * @param {object} internal_request  Internal Request
 */
const InternalRequestDetail = ({ internal_request }) => (
  <>
    <Row>
      <Col md={ 6 }>
        <InternalRequestCard internal_request={ internal_request } />
      </Col>
    </Row>
  </>
)

InternalRequestDetail.propTypes = propTypes

export default InternalRequestDetail